import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import cloudbuildPlugin from '@backstage-community/plugin-cloudbuild/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { authModule } from './modules/auth';

export default createApp({
  features: [
    catalogPlugin,
    apiDocsPlugin,
    cloudbuildPlugin,
    navModule,
    homeModule,
    authModule,
  ],
});
